import { Col as Bs5Col } from 'react-bootstrap5';

export default Bs5Col;
